import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { MainNav, TopNav } from "../components/Header"
import Footer from "../components/Footer"
import "../theme/global.less"
import PageNotFound from "../pages/404"

export default function Layout({ children, module_name, page_name }) {
  const { settings } = useStaticQuery(graphql`
    query themeQuery {
      settings {
        theme {
          background_color
        }
        status_page {
          module_name
          page_name
          isActive
        }
      }
    }
  `)
  const theme = settings.theme.background_color
  const flatterdStausPage = settings.status_page.length > 0 ? settings.status_page.reduce((acc, val) => {
    if (Array.isArray(val)) {
      acc = [...acc, ...val]
    } else {
      acc = [...acc, val]
    }
    return acc
  }, []) : [];
  const pageStatus = flatterdStausPage.find(
    d => d.module_name === module_name && d.page_name === page_name
  )

  if (pageStatus && pageStatus.isActive !== 1) {
    return <PageNotFound />
  }

  // console.log(flatterdStausPage)

  return (
    <>
      <TopNav
        className="hide-mobile"
        address="Gedung Danadyaksa Cikini, Jl. Cikini Raya No.91A-D, Menteng, Jakarta Pusat"
        phone="134, +62-21-23507011"
        theme={theme}
      />
      <MainNav />

      <React.Fragment>{children}</React.Fragment>

      <Footer theme={theme} />

      {/* {flatterdStausPage.map(function (item, i) {
          return(
            item.isActive === 0 && (
              <style>
                {
                  `
                    [data-page="${item.page_name}"] {
                      display: none !important;
                    }
                  `
                }
              </style>
            )
          )
        })} */}
    </>
  )
}
